import { useEffect, useState } from 'react';
import type { SizerService } from '../../application/services/SizerService';

export function useSizerEnabled(sizerService: SizerService | null) {
  const [isSizerEnabled, setIsSizerEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!sizerService) {
      return;
    }

    let cancelled = false;

    // eslint-disable-next-line react-hooks/set-state-in-effect -- start async fetch; state updates happen only from promise callbacks
    setIsLoading(true);

    void sizerService
      .isSizerEnabled()
      .then((enabled) => {
        if (!cancelled) setIsSizerEnabled(enabled);
      })
      .catch(() => {
        if (!cancelled) setIsSizerEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [sizerService]);

  return {
    isSizerEnabled: sizerService ? isSizerEnabled : false,
    isLoading: sizerService ? isLoading : false,
  };
}
